var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "", align: "center" } },
    [
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: "12" } },
        [
          !_vm.suppliersList.length
            ? _c(
                "div",
                {
                  staticClass: "d-flex justify-center align-center",
                  staticStyle: {
                    width: "100%",
                    "min-height": "calc(100vh - 300px)",
                  },
                },
                [
                  _c("v-empty-state", {
                    attrs: {
                      type: "suppliers",
                      id: "document",
                      height: 180,
                      customClass: "mt-6",
                      hiddenDescription: !_vm.emptyDescription,
                      isFree: true,
                      title: _vm.emptyTitle,
                      description: _vm.emptyDescription,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "actions",
                          fn: function () {
                            return [_vm._t("empty-actions")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              )
            : [
                _c("v-simple-table", {
                  key: _vm.reset,
                  class: [
                    {
                      "fixed-table":
                        _vm.$store.state.base.isExpandNavigationDrawer,
                    },
                  ],
                  attrs: { height: _vm.heightTable, "fixed-header": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c("VTableHeaders", {
                            attrs: { headers: _vm.headers },
                            on: { sort: _vm.setSort },
                          }),
                          _c("v-divider", {
                            staticStyle: {
                              position: "absolute",
                              "margin-top": "-6px",
                              "margin-left": "-5px",
                              "z-index": "2",
                              "min-width": "100%",
                            },
                          }),
                          _c(
                            "tbody",
                            { key: _vm.resetScroll },
                            _vm._l(_vm.suppliersList, function (item, i) {
                              return _c(
                                "tr",
                                {
                                  directives: [
                                    {
                                      name: "intersect",
                                      rawName: "v-intersect",
                                      value:
                                        _vm.useInfiniteScroll &&
                                        i + 1 === _vm.suppliersList?.length
                                          ? _vm.onLoadMore
                                          : "",
                                      expression:
                                        "useInfiniteScroll && (i + 1) === suppliersList?.length ? onLoadMore : ''",
                                    },
                                  ],
                                  key: i,
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToSupplier(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "td",
                                    { staticClass: "body-2" },
                                    [
                                      item.name || item.tax_id
                                        ? [
                                            item.name
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-1 d-inline-block text-truncate",
                                                    staticStyle: {
                                                      "max-width": "95%",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-block body-2 text--disabled font-italic",
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                            item.tax_id
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mt-n1 caption grey-300--text d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("generals.RUT")
                                                      ) +
                                                        " " +
                                                        _vm._s(item.tax_id)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text--disabled font-italic",
                                            },
                                            [_vm._v("Sin especificar")]
                                          ),
                                    ],
                                    2
                                  ),
                                  _c("td", { staticClass: "body-2" }, [
                                    item.tax_settings
                                      ?.cl_activity_description ||
                                    item.business_activity
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-inline-block text-truncate",
                                            staticStyle: { "max-width": "96%" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.tax_settings
                                                  ?.cl_activity_description ||
                                                  item.business_activity
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 text--disabled",
                                          },
                                          [_vm._v("Sin especificar")]
                                        ),
                                  ]),
                                  _vm.showCategoryColumn
                                    ? _c(
                                        "td",
                                        { staticClass: "body-2" },
                                        [
                                          _vm.getCategoryName(item) &&
                                          _vm.getCategoryName(item) !==
                                            "Bloqueados" &&
                                          !_vm.isDefaultSegment(item.segment_id)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "96%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getCategoryName(item)
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm.getCategoryName(item) ===
                                              "Bloqueados"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  staticClass:
                                                    "font-weight-semibold",
                                                  attrs: {
                                                    color: "greyMedium",
                                                    small: "",
                                                    label: "",
                                                  },
                                                },
                                                [
                                                  _vm._v("Bloqueados"),
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { right: "" } },
                                                    [_vm._v("mdi-lock")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled",
                                                },
                                                [
                                                  _vm._v(
                                                    "Sin categoría asociada"
                                                  ),
                                                ]
                                              ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("td", { staticClass: "body-2 text-end" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateTimeSecond")(item.created)
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "text-end" },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-click": "",
                                            "close-on-content-click": "",
                                            "offset-y": "",
                                            left: "",
                                            "nudge-bottom": 10,
                                            "nudge-left": 10,
                                            transition: "slide-y-transition",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "mr-n4",
                                                            attrs: {
                                                              text: "",
                                                              "x-small": "",
                                                              disabled:
                                                                _vm.getCategoryName(
                                                                  item
                                                                ) ===
                                                                "Bloqueados",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-500",
                                                              size: "24",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-dots-vertical"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            { staticClass: "pa-0" },
                                            [
                                              item.segment_id &&
                                              item.segment_id.length > 0 &&
                                              !_vm.isDefaultSegment(
                                                item.segment_id
                                              )
                                                ? _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "px-3",
                                                      attrs: { ripple: false },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.$emit(
                                                            "delete",
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "body-2 d-flex align-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey-500",
                                                                size: "16",
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-folder-minus"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "Eliminar de la categoria "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              !item.segment_id ||
                                              item.segment_id.length === 0 ||
                                              _vm.isDefaultSegment(
                                                item.segment_id
                                              )
                                                ? _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "px-3",
                                                      attrs: { ripple: false },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.$emit(
                                                            "add",
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "body-2 d-flex align-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey-500",
                                                                size: "16",
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-folder-plus"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "Agregar a categoria "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              item.segment_id &&
                                              item.segment_id.length > 0 &&
                                              !_vm.isDefaultSegment(
                                                item.segment_id
                                              )
                                                ? _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "px-3",
                                                      attrs: { ripple: false },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.$emit(
                                                            "change",
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "body-2 d-flex align-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey-500",
                                                                size: "16",
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-swap-horizontal"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "Cambiar de categoria "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }